export default {
  nav: {
    home: "Home",
    categories: "Categories",
    guides: "Guides",
    buyingGuide: "Buying Guide",
    faq: "FAQ",
  },
  hero: {
    badge: "Independent AllChinaBuy Resource",
    title: "AllChinaBuy Spreadsheet 2026",
    subtitle: "Explore organized AllChinaBuy finds, product categories, QC references, shipping guides and practical buyer resources — all in one place.",
    ctaSpreadsheet: "allchinabuy spreadsheet",
    ctaBuy: "Buy it now",
    ctaGuide: "Read the beginner guide",
  },
  categories: {
    title: "Browse the Spreadsheet Categories",
    subtitle: "Jump straight to your favorite product category on the full spreadsheet.",
    browse: "Browse",
    shoes: "Shoes",
    hoodies: "Hoodies/Sweaters",
    tshirts: "T-Shirts",
    jackets: "Jackets",
    pants: "Pants/Shorts",
    headwear: "Headwear",
    sets: "Sets",
    underwear: "Underwear/Underpants",
    jersey: "Jersey",
    accessories: "Accessories",
    bags: "Bags",
    belts: "Belts",
    perfumes: "Perfumes",
    other: "Other Stuff",
  },
  why: {
    title: "Why Use the AllChinaBuy Spreadsheet?",
    subtitle: "A simple, organized way to research products before you buy.",
    f1t: "Organized Finds",
    f1d: "Curated product links grouped by category, so you skip hours of scrolling.",
    f2t: "QC References",
    f2d: "Learn what to check in quality control photos before you ship.",
    f3t: "Shipping Clarity",
    f3d: "Understand weight, volumetric weight and how to reduce shipping cost.",
    f4t: "Beginner Friendly",
    f4d: "Clear steps that help first-time buyers order with confidence.",
  },
  guides: {
    title: "AllChinaBuy Guides & Articles",
    subtitle: "Original, independent guides to help you buy smarter.",
    readMore: "Read article",
  },
  faq: {
    title: "Frequently Asked Questions",
    q1: "What is the AllChinaBuy spreadsheet?",
    a1: "It's a community-compiled collection of curated product links and finds, organized by category, to help shoppers discover items and reference QC and shipping details more easily.",
    q2: "Is this site the official AllChinaBuy website?",
    a2: "No. This is an independent informational resource and is not affiliated with AllChinaBuy. Prices, shipping rates and policies can change, so always verify before purchasing.",
    q3: "Do the category buttons take me to the main spreadsheet?",
    a3: "Yes. Each category button links out to the corresponding category on the main spreadsheet site.",
    q4: "Do I need an account to browse?",
    a4: "No account is needed to explore the guides and category links on this site.",
    q5: "Can I trust the shipping and coupon info?",
    a5: "Information on this site is for reference only. Always confirm current prices, coupons and shipping rates on the official site before you order.",
  },
  cta: {
    title: "Ready to Explore the Full Spreadsheet?",
    subtitle: "Head over to the main site to browse the complete, always-updated product spreadsheet.",
    button: "Open the AllChinaBuy Spreadsheet",
  },
  footer: {
    tagline: "An independent resource for AllChinaBuy shoppers.",
    disclaimerTitle: "Disclaimer",
    disclaimer: "This is an independent informational resource and is not affiliated with AllChinaBuy. Prices, shipping rates, coupons, sellers and policies may change. Always verify current information before purchasing. All external links open in a new tab.",
    rights: "© 2026 AllChinaBuy Spreadsheet. All rights reserved.",
  },
};